<!-- Back navigation -->
<button mat-flat-button class="home" [routerLink]="['/hem']">
  <mat-icon>arrow_back</mat-icon> Till startsidan
</button>

<h2>Hantera återköp</h2>

<p class="explanation">
  För att göra ett återköp måste du först välja en artikel; därefter kan du välja återbetalningsmetod.
</p>

<!-- Order info -->
<section class="order-summary">
  <h3>Ordersummering #{{order?.orderId}}</h3>
  <mat-radio-group [formControl]="refundItem">
    @for (item of order?.orderItems; track item) {
      <div>
        <div class="item-info">
          @if (item.orderItemType === 'FEATURE') {
            <span class="item-label"><b>{{item.feature?.name}}</b></span>
          }
          @if (item.orderItemType === 'RESOURCE') {
            <span class="item-label">
              <b>{{item.booking?.registrationNumber}}</b> (Bokning)
            </span>
          }
          @if (item.orderItemType === 'PREPAIDTICKET') {
            <span class="item-label">
              <b>{{item.prepaidTicket?.name}}</b> (Abonnemang)
            </span>
          }
          <div>
            <span>{{item.amountPaid}} kr</span>
            @if (!isDisabled(item)) {
              <mat-radio-button [value]="item"></mat-radio-button>
            }
          </div>
        </div>
        @if (item.discount) {
          <div class="discount">
            <i>Rabatt: </i><i>- {{item.discount}} kr</i>
          </div>
        }
      </div>
    }
  </mat-radio-group>
  <div class="total-amount">
    <p><strong>{{(order?.amountToPay || 0) > 0 ? 'Kvar att betala': 'Kvar att återbetala'}}:</strong>
    <strong>{{order?.amountToPay}} kr</strong>
  </p>
</div>
</section>


<!-- Refund options -->
<div class="refund-options">
  <div>
    <h4>Betalningar</h4>
    @for (payment of order?.payments; track payment) {
      <div class="payment-info">
        @if (payment.transactionType !== 'REFUND') {
          <span class="payment-details"
            [title]="payment.externalOrderId ? 'Kustom order-ID: ' + payment.externalOrderId : ''">
            <p>{{payment.paymentMethod?.label}}</p>
            <p class="transaction-date">{{payment.transactionDate | date: 'yyyy-MM-dd'}}</p>
          </span>
        }
        @if (payment.transactionType !== 'REFUND') {
          <span class="amount-and-btn">
            <p class="payment-details">{{payment.amount}} kr</p>
            @if (allowPayments) {
              <button class="button slim success refund-btn" (click)="refundPayment(payment)"
                [title]="!refundItem.value ? 'Välj artikel för återbetalning' : 'Starta återbetalning'"
                [disabled]="!refundItem.value"><mat-icon class="replay">input</mat-icon>
              </button>
            }
          </span>
        }
      </div>
    }
  </div>

  <!-- Finished refunds -->
  @if (refundExists) {
    <div>
      <h4>Återbetalningar</h4>
      @for (payment of order?.payments; track payment) {
        <div class="payment-info finished-refunds">
          @if (payment.transactionType === 'REFUND') {
            <span
              [title]="payment.externalOrderId ? 'Kustom order-ID: ' + payment.externalOrderId : ''">
              <p>{{payment.paymentMethod?.label}}</p>
              <p class="transaction-date">{{payment.transactionDate | date: 'yyyy-MM-dd'}}</p>
              <p class="transaction-date">{{payment.comment}}</p>
            </span>
          }
          @if (payment.transactionType === 'REFUND') {
            <span>
              <p>-{{payment.amount}} kr</p>
            </span>
          }
        </div>
      }
    </div>
  }

  <!-- Unfinished started payments -->
  @if (startedPayments?.length) {
    <app-unfinished-payments
    [startedPayments]="startedPayments"></app-unfinished-payments>
  }

  <!-- Navigation after refund -->
  <div class="nav-buttons">
    @if (bookingId) {
      <button class="button success slim" (click)="goToBooking(bookingId)">
        Gå till detaljsidan
      </button>
    }
    @if (prepaidExists) {
      <button class="button success slim" [routerLink]="['/abonnemang']">
        Gå till abonnemang
      </button>
    }
  </div>
</div>

<!-- Receipt -->
<iframe #iframe id="iframe" name="iframe">
</iframe>